import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { eventNames } from 'process';
import { lessondetails } from 'src/app/models/module/moduledetails';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';

@Component({
  selector: 'app-classlist',
  templateUrl: './classlist.component.html',
  styleUrls: ['./classlist.component.css']
})
export class ClasslistComponent implements OnInit {
  @Input() lessons: any;
  @Input() admin: boolean;
  @Input() canViewLessons: boolean;
  @Output() errormessage: EventEmitter<string> = new EventEmitter();
  @Output() successmessage: EventEmitter<string> = new EventEmitter();
  @Output() lessonlist: EventEmitter<lessondetails> = new EventEmitter();
  constructor(private classmanager: ClassmanagementService, private route: Router, private toastr: ToastrService) { }

  ngOnInit(): void {
    console.log("canViewLessons:: "+this.canViewLessons);

  }
  getHTMLIDRef(id: string) {
    return `#collapse${id}`;
  }

  // gotolesson(classid: number, moduleid: number) {
  //   this.route.navigate(['user/lesson'], { queryParams: { 'moduleid': moduleid, 'classid': classid } });
  // }

  deleteclicked(classid: number, moduleid: number) {
    this.classmanager.classhascontent(classid).subscribe(
      (data: any) => {
        let hascontent: boolean = data;
        if (hascontent) {
          var proceed = confirm("The Lesson You Are About To Delete Has Content. Are you sure you want to proceed?");
          if (proceed) {
            this.deletelesson(classid, moduleid);
          }
        }
        else {
          var proceed = confirm("Are you sure you want to proceed?");
          if (proceed) {
            this.deletelesson(classid, moduleid);
          }
        }
      },
      (err: HttpErrorResponse) => {
        if (err.status === 0) {
          this.errormessage.emit("Unable to connect to server");
        }
        else if (err.status === 400) {
          this.errormessage.emit(err.error.message);
        }
      }
    );
  }

  deletelesson(classid: number, moduleid: number) {
    this.classmanager.deleteclass(classid, moduleid).subscribe(
      (data: any) => {
        this.lessons = data;
        this.successmessage.emit("Deleted Successfully");
      },
      (err: HttpErrorResponse) => {
        if (err.status === 0) {
          this.errormessage.emit("Unable to connect to server");
        }
        else if (err.status === 400) {
          this.errormessage.emit(err.error.message);
        }
      }
    );
  }

  edit(id: number) {
   // debugger;
    let editor = document.getElementById(id.toString());
    editor.setAttribute("style", "display:block;");
    let btns = document.getElementsByName(id.toString());
    for (let index = 0; index < btns.length; index++) {
      const element = btns[index];
      element.setAttribute("style", "display: initial;");
    }
  }

  reloadlesson(lessons: any) {
    this.lessons=lessons;
  }

  async movelessondown(e: Event, lessonid:number, lessontitle: string, moduleid:number)
  {
    e.stopPropagation();
    this.toastr.warning('Moving Lesson Down', lessontitle);
    this.lessons=await this.classmanager.movelessondown(lessonid,moduleid).toPromise();
    this.toastr.success('Moved Lesson Down', lessontitle);
  }

  async movelessonup(e: Event, lessonid:number, lessontitle: string, moduleid:number)
  {
    e.stopPropagation();
    this.toastr.warning('Moving Lesson Up', lessontitle);
    this.lessons=await this.classmanager.movelessonup(lessonid,moduleid).toPromise();
    this.toastr.success('Moved Lesson Up', lessontitle);
  }
}
